// extracted by mini-css-extract-plugin
module.exports = {"video":"video__3jKnv","modalOverlay":"modalOverlay__2yU2Q","modal":"modal__2qPFS","closeButton":"closeButton__1V-Zk","CTA":"CTA__3WS28","btn":"btn__4qmw8"};